<template>
  <v-menu
    ref="menu1"
    :disabled="readonly"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        filled
        :readonly="readonly"
        v-model="value"
        :label="label"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="value"
      no-title
      :readonly="readonly"
      range
    ></v-date-picker>
    <div class="bottom-area">
      <v-btn
        small
        @click="menu=false"
        color="primary"
      >Confim</v-btn>
      <v-btn
        small
        @click="clearClose()"
      >Clear</v-btn>
    </div>
  </v-menu>
</template>

<script>
  export default {
    name: 'DatePickerRange',
    props: {
      label: {
        default: 'Date',
      },
      value: {
        default: null,
      },
      readonly: {
        default: false,
      },
    },
    watch: {
      value: function (newValue) {
        this.$emit('input', newValue)
      },
    },
    data: () => ({
      menu: false,
    }),
    methods: {
      clearClose () {
        this.$emit('input', [])
        this.menu = false
      },
    },
  }
</script>

<style scoped>
.bottom-area {
  background-color: #E1E1E1;
  padding: 10px;
}
</style>
